import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'

export default class extends Controller {
  static targets = ['element']

  elementTargetConnected(element) {
    tippy(element)
  }
}
